__turbopack_context__.v({
  "accordionSlideOverwrite": "bannerGallery-module-scss-module__0EJXUW__accordionSlideOverwrite",
  "bannerGallery": "bannerGallery-module-scss-module__0EJXUW__bannerGallery",
  "bannerOption": "bannerGallery-module-scss-module__0EJXUW__bannerOption",
  "bannerOptionImage": "bannerGallery-module-scss-module__0EJXUW__bannerOptionImage",
  "bannerOptionSelected": "bannerGallery-module-scss-module__0EJXUW__bannerOptionSelected",
  "fadeIn": "bannerGallery-module-scss-module__0EJXUW__fadeIn",
  "fadeOut": "bannerGallery-module-scss-module__0EJXUW__fadeOut",
  "galleryOptions": "bannerGallery-module-scss-module__0EJXUW__galleryOptions",
  "galleryPreview": "bannerGallery-module-scss-module__0EJXUW__galleryPreview",
  "galleryPreviewImage": "bannerGallery-module-scss-module__0EJXUW__galleryPreviewImage",
  "galleryPreviewPlaceholder": "bannerGallery-module-scss-module__0EJXUW__galleryPreviewPlaceholder",
  "galleryPreviewPlaceholderText": "bannerGallery-module-scss-module__0EJXUW__galleryPreviewPlaceholderText",
  "label": "bannerGallery-module-scss-module__0EJXUW__label",
  "labelRequired": "bannerGallery-module-scss-module__0EJXUW__labelRequired",
  "scaleIn": "bannerGallery-module-scss-module__0EJXUW__scaleIn",
  "scaleOut": "bannerGallery-module-scss-module__0EJXUW__scaleOut",
  "zoomIn": "bannerGallery-module-scss-module__0EJXUW__zoomIn",
  "zoomOut": "bannerGallery-module-scss-module__0EJXUW__zoomOut",
});
